import React, { useEffect, useState } from 'react';
import { convertDateToTimeZone, DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';

import s from './styles.module.scss';

interface IProps {
  timezone?: string;
}

const LocalTimeCol: React.FC<IProps> = ({ timezone }) => {
  if (!timezone) return '-';

  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, 60_000);

    return () => clearInterval(interval);
  }, []);

  return (
    <span className={s.text}>
      {DateFormatter({
        date: convertDateToTimeZone(now, timezone),
        format: DateFormats['hh:mm a'],
      })}
    </span>
  );
};

export default LocalTimeCol;
